import { render, staticRenderFns } from "./bsRcToCenter.vue?vue&type=template&id=4dc60e94&scoped=true&"
import script from "./bsRcToCenter.vue?vue&type=script&lang=js&"
export * from "./bsRcToCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc60e94",
  null
  
)

export default component.exports